










































import { Component, Prop, Vue } from 'vue-property-decorator';
import ColorPicker from './TypeCard/ColorPicker.vue';
import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';

@Component({
  components: {
    ColorPicker,
  },
})
export default class NewTypeCard extends Vue {
  private type = {
    atWork: false,
    colorBg: '#12AAAA',
    colorFg: '#FFFFFF',
    name: '',
  };

  private addLeaveType() {
    request('post', `leave-types`, this.type).then(() => {
      this.$store.dispatch('leaveTypes/updateLeaveTypes', { force: true });
    });
  }
}
